/* ==========================================================================
   OMNI Quiz Vol. 4 - Funnel 3 · Men 30+
   Copy follows the Figma "SPs - Support Pages" Men frames; flow, branching
   and scoring follow omni-quiz-funnel.html (Scoring & Personalization v4).
   The landing asks age (not gender); gender is fixed to male.
   Option order matters: scoring in quiz-vol4-engine.js reads answer indices.
   ========================================================================== */
(function () {
  'use strict';

  var S = {
    single: 'Please select one',
    multi: 'Please select all that apply'
  };

  window.OMNI_QUIZ_V4_FUNNELS = window.OMNI_QUIZ_V4_FUNNELS || {};

  window.OMNI_QUIZ_V4_FUNNELS.men = {
    id: 'men',
    name: 'Men’s Weight-Loss & Strength Assessment',
    promo: 'OMNIQUIZ-MEN',

    /* Clinicians' Choice card: set the number and the 3 photos by hand */
    frontrow: {
      count: '675',
      photos: [
        'https://assets.app.thefrontrowhealth.com/yulyi33mil8glzv4b7fhzs5ipnz2',
        'https://assets.app.thefrontrowhealth.com/rdpnv5i5g5jmw9nl1c2udq4l2szf',
        'https://assets.app.thefrontrowhealth.com/pa8nliuewz7t7g0dmxjawwf0kr5a'
      ]
    },
    landing: {
      heroImage: 'menHero',
      heroImageMobile: 'menHeroMobile',
      tallMobileImage: true,
      textLeft: true,
      title: 'Don’t feel like the man you used to be?',
      lead: 'Lost muscle is the #1 reason energy, strength and drive fade after 30 - and creatine is the most proven way to get it back.',
      bullets: ['Strength and mental edge come back', 'Energy lasts from morning to night', 'Body looks leaner and harder', 'Recovery stops taking a week'],
      bulletsTight: true,
      question: 'Start by selecting your age:',
      ages: ['30 - 39', '40 - 49', '50 - 59', '60+'],
      press: ['Healthline', 'Men’s Health', 'Women’s Health']
    },

    /* the landing answers "age"; this hidden entry gives it labels for the profile + tracking */
    steps: [
      { type: 'single', id: 'age', hidden: true, opts: ['30-39', '40-49', '50-59', '60+'] },

      { type: 'single', id: 'gained', h1: 40, yn: true, title: 'Have you gained unwanted weight or lost muscle in the last year?', sub: S.single,
        opts: ['Yes', 'No'] },

      { type: 'single', id: 'athletic', title: 'Were you more athletic in the past?', sub: S.single,
        opts: ['Yes - I played competitive sports', 'I was pretty active', 'Not really'],
        why: 'Former athletes lose trained muscle fastest when they stop - which is why the weight shows up quicker too.' },

      { type: 'single', id: 'body25', title: 'What did your body look like at 25?', sub: 'Be honest - this sets your baseline',
        opts: ['Lean no matter what I ate', 'Athletic and strong', 'Already carrying extra', 'Skinny - the weight came later'],
        why: 'The gap between your body then and now tells us how much muscle you’ve lost - and lost muscle is the most fixable part of a slowed metabolism.' },

      { type: 'bodymap', id: 'areas', title: 'Which areas bother you the most?', sub: 'Please tap all areas that apply' },

      { type: 'multi', id: 'physical', title: 'Have you noticed other physical changes?', sub: S.multi,
        opts: ['Decreased muscle mass', 'Loss of strength / lifts going down', 'Softer overall physique', 'Weaker grip', 'Slower recovery', 'None of these'],
        none: [5] },

      { type: 'single', id: 'energy', title: 'What are your energy levels during the day?', sub: S.single,
        opts: ['Wake up already tired', 'Crash in the afternoon', 'Vary throughout the day', 'Pretty consistent'] },

      { type: 'single', id: 'drive', title: 'Which best describes your motivation and drive?', sub: S.single,
        opts: ['Lost my competitive edge', 'Less motivated to pursue my goals', 'Still driven, but not like I used to be', 'Ambitious and motivated as ever'] },

      { type: 'multi', id: 'mood', title: 'Have you noticed any changes in how you feel?', sub: S.multi,
        opts: ['Irritable and short-tempered', 'More anxious and stressed', 'Burned out and overwhelmed', 'Foggy / can’t focus', 'None of these'],
        none: [4] },

      { type: 'multi', id: 'lowt', title: 'Any of these classic low-testosterone signs?', sub: S.multi,
        opts: ['Lower sex drive than before', 'Tired even after a full night’s sleep', 'Belly fat that won’t budge', 'Muscle that’s hard to build or keep', 'None of these'],
        none: [4],
        why: 'Extra body fat and low testosterone reinforce each other - fat tissue converts testosterone to estrogen. Losing fat while rebuilding muscle is the strongest natural lever to break the loop.' },

      { type: 'single', id: 'howlong', title: 'How long have you been carrying this extra weight?', sub: S.single,
        opts: ['Less than 6 months', '6 months to 1 year', '1-3 years', '3+ years'] },

      { type: 'single', id: 'meals', title: 'How does eating look on a typical day?', sub: S.single,
        opts: ['Skip breakfast, big dinner', 'Grab whatever’s around', '2-3 proper meals', 'Planned meals, tracked protein'] },

      { type: 'single', id: 'hunger', title: 'How would you describe your hunger?', sub: S.single,
        opts: ['I’m hungry all the time', 'Fine all day - ravenous at night', 'I eat from stress or boredom, not hunger', 'Normal - hunger isn’t my problem'],
        why: 'Constant or evening hunger usually tracks blood-sugar swings and low muscle mass - muscle is where carbs get stored. More muscle, steadier hunger.' },

      { type: 'single', id: 'alcohol', title: 'How often do you drink alcohol?', sub: S.single,
        opts: ['Rarely / never', 'Weekends only', 'A few times a week', 'Daily'] },

      { type: 'single', id: 'meds', h1: 40, yn: true, title: 'Do you take any medications?', sub: S.single,
        opts: ['I do', 'No'] },

      { type: 'multi', id: 'medlist', title: 'To understand your health better, which medications are you taking?', sub: S.multi,
        showIf: function (a) { return a.meds == null || a.meds === 0; },
        opts: ['GLP-1 (Ozempic, Wegovy, Zepbound...)', 'Blood pressure medication', 'Antidepressants', 'Hormones / HRT', 'Thyroid medication', 'None of the above'],
        none: [5] },

      { type: 'multi', id: 'tried', title: 'To understand your situation, what have you tried?', sub: S.multi,
        opts: ['Haven’t tried anything', 'Dieting / calorie counting', 'Creatine powder (quit - taste / bloating)', 'Pre-workout', 'TRT / test boosters', 'More cardio'],
        none: [0] },

      { type: 'info', id: 'info1', title: 'We got you!', lead: 'Men who add creatine to resistance training gain significantly more lean mass and strength than training alone.*',
        image: 'infoPack',
        intro: 'So we built OMNI Creatine Gummy to help you:',
        introLeft: true,
        bullets: ['Rebuild muscle and strength', 'Restore all-day energy and drive', 'Look leaner and harder - no powders, no bloating'],
        fine: '* Meta-analyses of creatine + resistance training in adults (Chilibeck et al. 2017; Candow et al. 2022). Individual results vary.' },

      { type: 'single', id: 'diet', title: 'How often do you eat red meat or fish?', sub: 'The only natural sources of creatine in food',
        opts: ['Every day', 'A few times a week', 'Occasionally', 'Rarely / never (plant-based)'],
        why: 'Red meat and fish are the primary dietary sources of creatine. Plant-based eaters typically carry 20-30% lower creatine stores.' },

      { type: 'single', id: 'event', title: 'Is there a moment you’d love to look your best for?', sub: S.single,
        opts: ['A vacation or trip', 'A wedding or big event', 'A reunion - seeing old friends', 'No event - I’m doing this for me'] },

      { type: 'single', id: 'pace', title: 'How fast would you like to see results?', sub: S.single,
        opts: ['As fast as possible', 'Steady and sustainable', 'No rush - I’m playing the long game'] },

      { type: 'height', id: 'height', title: 'What’s your height?' },
      { type: 'weight', id: 'weight', title: 'What’s your current weight & goal?',
        note: 'Results are not guaranteed. Creatine stores typically saturate in 3-4 weeks with daily use; body-composition changes depend on training and diet.' },
      { type: 'loader', id: 'loader', title: 'Building your creatine protocol...',
        checks: ['Evaluating your answers...', 'Estimating your creatine stores...', 'Matching clinical dosing data...', 'Building your protocol...'] },
      { type: 'email', id: 'email', label: 'Your match is ready', title: 'One step left to see your protocol',
        text: 'We’ll also let you know when <b>OMNI free samples</b> are available.' }
    ],

    /* ---- personalised result pages (R1-R7) + checkout ---- */
    results: {
      audience: '12,400+ men',
      matchedTo: 'Matched to your age group and goals.',
      chartTitle: 'Your strength & lean mass projection',
      guide: 'Creatine for Men',
      goalFallback: 'Rebuild strength',
      driversWhat: 'draining your creatine',
      triedFallbackTitle: 'Why those didn’t stick - and why this will',
      profileTweak: function (rows, a, label) {
        return rows.map(function (r) {
          return r[0] === 'Strength training' ? ['Symptoms for', label('howlong', a.howlong) || '-'] : r;
        });
      },
      goal: function (delta, fmt) {
        return delta > 0 ? 'drop ' + fmt(delta) + ' of fat and rebuild strength' : 'rebuild muscle & drive';
      },
      reviews: [
        ['Mark D., 44', 'Lifts went up for the first time in years. Energy from morning to night.'],
        ['Chris P., 52', 'Felt like I got my edge back - at work and in the gym. Quit the powder years ago because of bloating; gummies fixed that.'],
        ['Tom R., 39', 'Leaner, harder, and recovery isn’t a week anymore.']
      ]
    }
  };
})();
